import { type ImageProps } from 'next/image';

import { WebpImage } from '@common/atoms/WebpImage';
import { ThumbnailWidth } from '@common/types/WebpWidth';
import styles from '@web/atoms/Avatar/Avatar.module.scss';

export enum AvatarSize {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    XLARGE = 'xlarge',
}

export interface Props extends Partial<ImageProps> {
    src?: string;
    userName?: string;
    size?: AvatarSize;
    isRounded?: boolean;
    isPremium?: boolean;
}

export const Avatar = ({ userName, className, size, isRounded, isPremium, src }: Props) => {
    const classes = [styles.Avatar];
    if (size) classes.push(styles[`Avatar-size--${size}`]);
    if (isRounded) classes.push(styles['is-rounded']);
    if (isPremium) classes.push(styles['is-premium']);
    if (className) classes.push(className);

    return (
        <WebpImage
            className={classes.join(' ')}
            defaultSize={ThumbnailWidth.WIDTH_110}
            src={src}
            alt={userName || ''}
            ratio={1}
            fallbackSrc={'/images/avatar_default.png'}
        />
    );
};
